import React from "react";

import Divider from "ui/Divider";
import { FormGroupTitle, FormTextField, FormDropdownLabeled } from "ui/Form";
import Skeleton from "ui/Skeleton";
import PropTypes from "prop-types";

const AddEditAccountFields = (props) => {
  const { loading, roleNames, isSuperuser, isEdit = false } = props;

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height="342px" />;
  }

  return (
    <>
      <FormGroupTitle title="User information" />
      <div className="dialog-content-row">
        <FormTextField
          name="username"
          label="User name"
          disabled={isEdit}
          autoComplete="new-password"
        />
        <FormDropdownLabeled
          name="groupname"
          label="Role name"
          items={roleNames}
          disabled={isSuperuser}
        />
      </div>
      <div className="dialog-content-row">
        <FormTextField name="first_name" label="First name" />
        <FormTextField name="last_name" label="Last name" />
      </div>
      <FormTextField name="email" label="Email" />
      <Divider />
      <FormGroupTitle title="Verification" />
      <div className="dialog-content-row">
        <FormTextField
          name="password"
          label="Password"
          type="password"
          autoComplete="new-password"
        />
        <FormTextField
          name="confirm_password"
          label="Confirm password"
          type="password"
        />
      </div>
    </>
  );
};

AddEditAccountFields.propTypes = {
  loading: PropTypes.bool,
  roleNames: PropTypes.array,
  isSuperuser: PropTypes.bool,
  isEdit: PropTypes.bool,
};

export default AddEditAccountFields;
